if (!window.eebAEMdigitalData) {
  window.eebAEMdigitalData = [];
}

export const trackSearchAnalytics = (
  eventName: string,
  query: string,
  numberOfResults: number,
  tabName = 'All results',
): void => {
  if (!query) return;

  const eventType =
    numberOfResults > 0 ? 'search result page load' : 'search_no_match';

  window?.eebAEMdigitalData?.push({
    event: eventType,
    page: {
      name: `ee:search results:${tabName}`,
      tab: tabName,
      login_value: 'not logged in',
      section: 'ee:search',
      site_tabs: 'ee:search',
      template_type: 'search results',
      url: window.location.href,
    },
    search: {
      keyword: query,
      number_results: numberOfResults,
    },
  });
};

export const trackResultItemClick = (
  keyword: string,
  position: number,
  linkTitle: string,
  linkUrl: string,
  componentTitle: string,
  componentType: string,
): void => {
  window?.eebAEMdigitalData?.push({
    event: 'search result click',
    click_detail: {
      name: linkTitle,
      type: 'search links',
      url: linkUrl,
    },
    component: {
      background_image: 'Not applicable',
      title: componentTitle,
      type: componentType,
    },
    search: {
      keyword: keyword,
      position: position,
    },
  });
};
